module.exports = __webpack_public_path__ + "img/darkgray-white-transition-clean.0f6ba138.png";